export default {
  en: {
    name: 'Name',
    email: 'E-Mail',
    phone: 'Phone Number',
    area: 'Which area would you like to work?',
    send: 'Send',
    sending: 'Sending...',
    selectOption: 'Select an option',
    your: 'Your',
    jobs: [
      {
        name: 'Select an option...',
        value: '',
      },
      {
        name: 'Administration',
        value: 'Administration',
      },
      {
        name: 'Operations',
        value: 'Operations',
      },
      {
        name: 'Customer Service',
        value: 'Customer Service',
      },
      {
        name: 'Promoter',
        value: 'Promoter',
      },
      {
        name: 'Other',
        value: 'Other',
      },
    ],
    error: 'There was an error proccessing your message, please trying again later.',
    success: 'Your message has been sent, we will keep in touch soon.',
  },
  es: {
    name: 'Nombre',
    email: 'E-Mail',
    phone: 'Télefono',
    area: '¿En qué área te interesa trabajar?',
    send: 'Enviar',
    sending: 'Enviando...',
    selectOption: 'Selecciona una opción',
    your: 'Tú',
    jobs: [
      {
        name: 'Selecciona una opción...',
        value: '',
      },
      {
        name: 'Administración',
        value: 'Administration',
      },
      {
        name: 'Operaciones',
        value: 'Operations',
      },
      {
        name: 'Atención al cliente',
        value: 'Customer Service',
      },
      {
        name: 'Promotoría',
        value: 'Promoter',
      },
      {
        name: 'Otro',
        value: 'Other',
      },
    ],
  },
};
